export const correctUploadPath = (path) => path.replace(/\\/g, "/");
